import React, { Suspense, lazy, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ExpiredPage = lazy(() => import("../pages/mpcz/ExpiredPage/ExpiredPage"));
const NotFound = lazy(() => import("../pages/mpcz/PageNotFound/NotFound"));
const RegisterComplaint = lazy(() => import("../pages/mpcz/RegisterComplaint/index"));
const ComplaintStatus = lazy(() => import("../pages/mpcz/ComplaintStatus/index"));
const LinkMobileNumber = lazy(() => import("../pages/mpcz/LinkMobileNumber/index"));
const SaralSanyojan = lazy(() => import("../pages/mpcz/SaralSanyojan/index"));
const SolorRoofTop = lazy(() => import("../pages/mpcz/SolorRoofTop/index"));
const RemoveMobileNumber = lazy(() => import("../pages/mpcz/RemoveMobileNumber/index"));
const LinkMobileNumberHT = lazy(() => import("../pages/mpcz/LinkMobileNumberHT/index"));

const MPCZRoutes = () => {
  const { checksum } = useSelector((state) => state.culturalHeritageReducer);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (checksum?.acceptLanguage) {
      i18n.changeLanguage(checksum.acceptLanguage);
    }
  }, [checksum?.acceptLanguage, i18n]);

  return (
    <>
      <Suspense fallback={<div className="loading"></div>}>
        <Routes>
          {/* MSEDCL Route */}
          <Route path="/cb/wa/mpcz/register-complaint/:checksum" >
            <Route index element={<RegisterComplaint />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/mpcz/complaint-status/:checksum" >
            <Route index element={<ComplaintStatus />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/mpcz/link-mobile/:Type/:checksum" >
            <Route index element={<LinkMobileNumber />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/mpcz/saral-sanyoan-status/:checksum" >
            <Route index element={<SaralSanyojan />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/mpcz/solar-roof-top-status/:checksum" >
            <Route index element={<SolorRoofTop />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/mpcz/remove-mobile/:Type/:checksum" >
            <Route index element={<RemoveMobileNumber />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/cb/wa/mpcz/ht-link-mobile/:checksum" >
            <Route index element={<LinkMobileNumberHT />} />
            <Route path="expired" element={<ExpiredPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>

      {/* Toast Notifications */}
      <ToastContainer />
    </>
  );
};

export default MPCZRoutes;
